import { KioskResource } from './KioskResource';

export class VisitingHoursDepartmentAndKioskResource {
    rid: number;
	kiosk: KioskResource;
}